// StatusSummary — enums and default configuration.

// How the summary renders: LEGEND shows the status names on a tinted bar,
// COUNTS shows the per-status numbers inline.
export const STATUS_SUMMARY_VARIANT = {
    LEGEND: 'legend',
    COUNTS: 'counts',
};

// Canonical outcome statuses of the recruitment funnel.
export const OUTCOME_STATUS = {
    NO_OUTCOME: 'no_outcome',
    WITHDRAWN: 'withdrawn',
    REJECTED: 'rejected',
    HIRED: 'hired',
};

// Visual tone of a status dot; each maps to a semantic color token in index.less.
export const DOT_TONE = {
    WARNING: 'warning',
    SECONDARY: 'secondary',
    DANGER: 'danger',
    SUCCESS: 'success',
    INFO: 'info',
};

// Default status → dot tone mapping (overridable per call site via `tones`).
export const DEFAULT_STATUS_TONES = {
    [OUTCOME_STATUS.NO_OUTCOME]: DOT_TONE.WARNING,
    [OUTCOME_STATUS.WITHDRAWN]: DOT_TONE.SECONDARY,
    [OUTCOME_STATUS.REJECTED]: DOT_TONE.DANGER,
    [OUTCOME_STATUS.HIRED]: DOT_TONE.SUCCESS,
};

// Source strings for the default status names; every render goes through t().
export const DEFAULT_STATUS_LABELS = {
    [OUTCOME_STATUS.NO_OUTCOME]: 'In progress',
    [OUTCOME_STATUS.WITHDRAWN]: 'Withdrawn',
    [OUTCOME_STATUS.REJECTED]: 'Rejected',
    [OUTCOME_STATUS.HIRED]: 'Hired',
};
